'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function createCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + value + expires + '; path=/';
}

function eraseCookie(name) {
  createCookie(name, '', -1);
}

function getCookie(name) {
  return document.cookie.split(';').map(function (cookiestring) {
    var coos = cookiestring.trim().split('=');
    if (coos.length === 2) {
      return {
        name: coos[0],
        value: coos[1]
      };
    }
    return null;
  }).filter(function (cookieObject) {
    return cookieObject.name === name;
  });
}

exports.createCookie = createCookie;
exports.eraseCookie = eraseCookie;
exports.getCookie = getCookie;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Cookies.js
// module id = 1196
// module chunks = 0